import './toast.css';

import { StateBanner } from '@kerfjs/ui/state-banner';
import { toast } from 'kerfjs/overlay';

type ToastVariant = 'brand' | 'success' | 'warning' | 'danger' | 'neutral';

/** Show brief, non-blocking feedback in the app's single toast stack. */
export function showToast(message: string, variant: ToastVariant = 'success'): void {
  if (typeof document === 'undefined') return;
  let region = document.querySelector<HTMLElement>('.app-toasts');
  if (region === null) {
    region = document.createElement('div');
    region.className = 'app-toasts';
    region.setAttribute('aria-live', 'polite');
    document.body.append(region);
  }
  toast(<StateBanner title={message} tone={variant === 'brand' ? 'pop' : variant} />, {
    container: region,
    className: 'app-toast',
    duration: 5000,
    role: variant === 'danger' ? 'alert' : 'status',
  });
}
